export default __webpack_public_path__ + "KaTeX_Math-BoldItalic.4d6241be0cb599314b9ae4af29d68d38.ttf";